import * as React from 'react';
import { Box, IconButton, Stack } from '@mui/material';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import HelpIcon from '@mui/icons-material/Help';
// import CustomDatePicker from './CustomDatePicker';
import NavbarBreadcrumbs from './NavbarBreadcrumbs';
import MenuButton from './MenuButton';
// import ColorModeIconDropdown from '../../shared-theme/ColorModeIconDropdown';

import Search from './Search';
import UserMenu from './UserMenu';
import { HELP_URL } from '../constants';

export default function AppHeader() {
  return (
    <Stack
      direction="row"
      sx={{
        display: { xs: 'none', md: 'flex' },
        width: '100%',
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'space-between',
        maxWidth: { sm: '100%', md: '1700px' },
        pt: 1.5,
      }}
      spacing={2}
    >
      <Box>
        {/* <Search /> */}
      </Box>
      {/* <NavbarBreadcrumbs /> */}
      <Stack direction="row" sx={{ gap: 3 }}>
        {/* <Search /> */}
        {/* <CustomDatePicker /> */}
        {/* <MenuButton showBadge aria-label="Open notifications">
          <NotificationsRoundedIcon />
        </MenuButton> */}
        <IconButton onClick={() => window.open(HELP_URL)}>
          <HelpIcon />
        </IconButton>
        {/* <MenuButton aria-label="Open notifications">
          <NotificationsRoundedIcon />
        </MenuButton> */}
        <UserMenu />
        {/* <ColorModeIconDropdown /> */}
      </Stack>
    </Stack>
  );
}